import React from "react";
import type {
  AssinaturaTvSetor,
  ProgressoItensTv,
} from "../../../../services/controleProducaoService";
import { AssinaturaLinha } from "./AssinaturaLinha";

export const GeralProgressBanner: React.FC<{
  geral: ProgressoItensTv;
  conferencia?: AssinaturaTvSetor | null;
  producaoTotal?: AssinaturaTvSetor | null;
  titulo?: string;
}> = ({
  geral,
  conferencia,
  producaoTotal,
  titulo = "Geral de todos os setores",
}) => {
  const completo = geral.pct >= 100 && geral.itensTotal > 0;
  const assinaturasLoja = [
    conferencia
      ? { key: "conferencia", label: "Conferência", assinatura: conferencia }
      : null,
    producaoTotal
      ? {
          key: "producao_total",
          label: "Produção total dos setores",
          assinatura: producaoTotal,
        }
      : null,
  ].filter(
    (item): item is { key: string; label: string; assinatura: AssinaturaTvSetor } =>
      item != null,
  );

  return (
    <div className="shrink-0 rounded-2xl border border-white/20 bg-black/20 p-4 sm:p-5 lg:p-6">
      <div className="min-w-0">
        <p className="text-xs font-black uppercase tracking-[0.16em] text-yellow-200 sm:text-sm">
          {titulo}
        </p>
        <div className="mt-1 flex items-end gap-4">
          <p
            className={`font-black tabular-nums leading-none ${
              completo ? "text-emerald-300" : "text-white"
            } text-6xl sm:text-7xl lg:text-8xl`}
          >
            {geral.pct}
            <span className="text-3xl sm:text-4xl lg:text-5xl">%</span>
          </p>
          <p className="pb-2 text-base font-semibold tabular-nums opacity-80 sm:text-xl lg:text-2xl">
            {geral.itensResolvidos}/{geral.itensTotal} itens concluídos
          </p>
        </div>
        <div
          className="mt-3 h-4 overflow-hidden rounded-full bg-black/30 sm:h-5"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={geral.pct}
          aria-label={`Progresso geral ${geral.pct}%`}
        >
          <div
            className={`h-full rounded-full transition-[width] duration-500 ${
              completo ? "bg-emerald-400" : "bg-yellow-300"
            }`}
            style={{ width: `${Math.min(100, Math.max(0, geral.pct))}%` }}
          />
        </div>
      </div>
      {assinaturasLoja.length > 0 ? (
        <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {assinaturasLoja.map((item) => (
            <div
              key={item.key}
              className="rounded-xl border border-white/15 bg-black/25 px-3 py-2.5 sm:px-4 sm:py-3"
            >
              <AssinaturaLinha
                compact
                label={item.label}
                assinatura={item.assinatura}
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
